import React from 'react';
import Navbar from '../../components/Layouts/Navbar';
import Footer from '../../components/Layouts/Footer';
import WordpressEntwicklungHeader from '../../components/WebDevelopment/WordpressEntwicklung/WordpressEntwicklungHeader';
import SubscribeStyleOne from '../../components/Common/SubscribeStyleOne';
import PageSeo from '../../components/Common/PageSeo';
import WordpressEntwicklungFAQ from '../../components/WebDevelopment/WordpressEntwicklung/WordpressEntwicklungFAQ';
import WordpressEntwicklungWeitereServices from '../../components/WebDevelopment/WordpressEntwicklung/WordpressEntwicklungWeitereServices';
import WordpressEntwicklungText from '../../components/WebDevelopment/WordpressEntwicklung/WordpressEntwicklungText';
import WordpressVerständnisundErfahrungfürIhreBranche from '../../components/WebDevelopment/WordpressEntwicklung/WordpressVerständnisundErfahrungfürIhreBranche';
import WordpressEntwicklungCTA from '../../components/WebDevelopment/WordpressEntwicklung/WordpressEntwicklungCTA';
import { useTranslations } from '../../locales/useTranslations';
import { useRouter } from 'next/router';

const WordpressEntwicklung = () => {
    const { t } = useTranslations();
    const { locale } = useRouter();
    const baseUrl = locale === 'en' ? 'https://simplify-data.com' : 'https://simplify-data.de';

    return (
        <>
            <PageSeo
                title={t('wordpressDevelopment_page_title')}
                description={t('wordpressDevelopment_page_description')}
                canonical={`${baseUrl}/web-development/wordpress-entwicklung/`}
                openGraph={{
                    url: `${baseUrl}/web-development/wordpress-entwicklung/`,
                    title: t('wordpressDevelopment_page_ogTitle'),
                    description: t('wordpressDevelopment_page_ogDescription'),
                    images: [
                        {
                            url: `${baseUrl}/images/logoog.png`,
                            width: 1200,
                            height: 1200,
                            alt: t('wordpressDevelopment_page_ogImageAlt1'),
                            type: 'image/jpeg',
                        },
                    ],
                    siteName: t('wordpressDevelopment_page_title'),
                    type: 'website'
                }}
                twitter={{
                    handle: '@simplify_data',
                    site: '@simplify_data',
                    cardType: 'summary_large_image',
                }}
                additionalMetaTags={[
                    {
                        name: 'robots',
                        content: 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1',
                    },
                    {
                        name: 'keywords',
                        content: t('wordpressDevelopment_page_keywords'),
                    },
                    {
                        name: 'author',
                        content: 'Simplify Data',
                    },
                    {
                        name: 'geo.region',
                        content: 'DE-SH',
                    },
                    {
                        name: 'geo.placename',
                        content: 'Kiel',
                    },
                    {
                        property: 'article:modified_time',
                        content: new Date().toISOString(),
                    },
                    {
                        name: 'format-detection',
                        content: 'telephone=no',
                    }
                ]}
                additionalLinkTags={[
                    {
                        rel: 'icon',
                        href: `${baseUrl}/images/favicon.png`,
                        type: 'image/png'
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'de',
                        href: `https://simplify-data.de/web-development/wordpress-entwicklung/`
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'en',
                        href: `https://simplify-data.com/web-development/wordpress-entwicklung/`
                    }
                ]}
            />

            <Navbar />
            <WordpressEntwicklungHeader />
            <WordpressVerständnisundErfahrungfürIhreBranche />
            <WordpressEntwicklungText />
            <WordpressEntwicklungCTA />
            <WordpressEntwicklungFAQ />
            <WordpressEntwicklungWeitereServices />
            <SubscribeStyleOne />
            <Footer />
        </>
    );
}

export default WordpressEntwicklung;